import { allUserData, getSettings, markPushed, pendingMutations, replaceFromBackup } from "../storage/db";
import { decryptJson, deriveKey, encryptJson } from "./crypto";
import type { BackupPayload } from "../domain/types";

export async function pushSync(passphrase: string): Promise<string> {
  const settings = await getSettings();
  if (!settings.cloudEndpoint || !settings.accessToken) return "Cloud sync не настроена";
  if (!navigator.onLine) return "Offline";
  const salt = settings.encryptionSalt;
  if (!salt) return "Создай ключ шифрования в настройках";
  const queue = await pendingMutations();
  const key = await deriveKey(passphrase, salt);
  const encrypted = await encryptJson(key, await allUserData());
  const response = await fetch(`${settings.cloudEndpoint.replace(/\/$/, "")}/sync/${settings.userId}`, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${settings.accessToken}`,
      "x-device-id": settings.deviceId
    },
    body: JSON.stringify({ encrypted, mutationCount: queue.length, clientUpdatedAt: new Date().toISOString() })
  });
  if (!response.ok) throw new Error(`Sync failed: ${response.status}`);
  await markPushed(queue.map((item) => item.id));
  return "Синхронизировано";
}

export async function pullSync(passphrase: string): Promise<string> {
  const settings = await getSettings();
  if (!settings.cloudEndpoint || !settings.accessToken) return "Cloud sync не настроена";
  if (!settings.encryptionSalt) return "Создай salt шифрования в настройках";
  const response = await fetch(`${settings.cloudEndpoint.replace(/\/$/, "")}/sync/${settings.userId}`, {
    headers: {
      authorization: `Bearer ${settings.accessToken}`,
      "x-device-id": settings.deviceId
    }
  });
  if (!response.ok) throw new Error(`Pull failed: ${response.status}`);
  const payload = (await response.json()) as { exists?: boolean; encrypted?: { iv: string; ciphertext: string } };
  if (payload.exists === false || !payload.encrypted) return "Облачной копии пока нет";
  const key = await deriveKey(passphrase, settings.encryptionSalt);
  const backup = await decryptJson<BackupPayload>(key, payload.encrypted);
  await replaceFromBackup(backup);
  return "Загружено из облака";
}
